import { initCookieConsentSync, resolveBannerVariantInBrowser } from '@clearscore-group/lib.helpers.cookie-consent-sync';

export default ({ COOKIEBOT_DOMAIN_ID, COOKIEBOT_VARIANT_A_DOMAIN_ID, COOKIEBOT_VARIANT_B_DOMAIN_ID }, callback) => {
    // Which of the two GB banner designs this visitor gets (SDUI-1604). Resolved here rather
    // than upstream because this is the last synchronous point before uc.js is injected, and
    // the id chosen has to be the id loaded. Returns the control everywhere else.
    const { cookiebotId } = resolveBannerVariantInBrowser({
        controlCookiebotId: COOKIEBOT_DOMAIN_ID,
        variantACookiebotId: COOKIEBOT_VARIANT_A_DOMAIN_ID,
        variantBCookiebotId: COOKIEBOT_VARIANT_B_DOMAIN_ID,
    });

    // Cookiebot's CookieConsent cookie is host-only and its own cross-subdomain sharing
    // cannot carry a decline, so carry the decision over ourselves before it boots. Keyed by
    // brand rather than by domain group, so it follows the visitor across groups and the
    // control id is passed because older builds only read the mirror named after it. This site is
    // built once per brand, and the SITE=drivescore build is www.drivescore.com.
    initCookieConsentSync(process.env.SITE === 'drivescore' ? 'drivescore' : 'clearscore', COOKIEBOT_DOMAIN_ID);

    const script = document.createElement('script');
    script.id = 'Cookiebot';
    script.src = 'https://consent.cookiebot.com/uc.js';
    script.dataset.cbid = cookiebotId;
    // script.dataset.blockingmode = 'auto';
    script.type = 'text/javascript';

    // Listen for successful load
    script.onload = () => {
        if (window.Cookiebot) {
            // eslint-disable-next-line no-console
            console.log('Cookiebot is available', window.Cookiebot);
            callback?.();
        } else {
            // eslint-disable-next-line no-console
            console.warn('Script loaded but Cookiebot not available yet');
            callback?.();
        }
    };

    // Listen for errors
    script.onerror = () => {
        // eslint-disable-next-line no-console
        console.log('Failed to load the Cookiebot script');
        callback?.();
    };

    document.head.appendChild(script);
};
